"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLanguageSwitcher = exports.useLanguage = exports.t = exports.InitLanguage = exports.i18n = void 0;
const i18next_1 = __importDefault(require("i18next"));
exports.i18n = i18next_1.default;
const react_i18next_1 = require("react-i18next");
const i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
const utils_1 = require("./utils");
const constants_1 = require("./constants");
const localeInstance = i18next_1.default.createInstance();
localeInstance.init({
    fallbackLng: 'en-GB',
});
const InitLanguage = (resourceName) => {
    i18next_1.default
        // load translation using /resourcesets/{name}/?language={language}
        .use(utils_1.BackendManager)
        // learn more: https://github.com/i18next/i18next-browser-languageDetector
        .use(i18next_browser_languagedetector_1.default)
        // pass the i18n instance to react-i18next.
        .use(react_i18next_1.initReactI18next)
        // init i18next
        // for all options read: https://www.i18next.com/overview/configuration-options
        .init({
        fallbackLng: constants_1.DEFAULT_LANGUAGE,
        initImmediate: false,
        keySeparator: '_',
        supportedLngs: constants_1.availableLanguages.map(({ value }) => value),
        backend: {
            resourceName,
            SaveManager: utils_1.SessionStoreManager,
        },
        debug: false,
        interpolation: {
            format(value, format, lng, options) {
                // use de-CH locale for fr-CH, defined it as rule
                const locale = lng === 'fr-CH' ? 'de-CH' : lng;
                return localeInstance.format(value, format, locale, options);
            },
            escapeValue: false,
            defaultVariables: {
                // number formatting
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
                currencyDisplay: 'code',
            },
        },
    })
        .then(() => {
        (0, utils_1.dispatchLanguage)(i18next_1.default.language);
    });
};
exports.InitLanguage = InitLanguage;
const t = (key, options) => i18next_1.default.t(key, options);
exports.t = t;
var hooks_1 = require("./hooks");
Object.defineProperty(exports, "useLanguage", { enumerable: true, get: function () { return hooks_1.useLanguage; } });
Object.defineProperty(exports, "useLanguageSwitcher", { enumerable: true, get: function () { return hooks_1.useLanguageSwitcher; } });
//# sourceMappingURL=i18n.js.map